module.exports = __webpack_public_path__ + "img/gsjs_bg.700ce4ca.jpg";